
import Vue from "vue";
import { FrontendFunc } from "@/models/frontend-func";
import { FrontendFuncParam } from "@/models/frontend-func-param";
import "codemirror/mode/javascript/javascript";
import AppFrontendFuncParameterList from "@/components/FrontendFuncParameterList.vue";

export default Vue.extend({
	data(){
		return {
			func: new FrontendFunc(),
			paramNamesValid: false
		};
	},
	props: {
		value: {
			type: Object as ()=>FrontendFunc,
			required: true
		}
	},
	computed: {
		nameValid():boolean {
			return FrontendFunc.validNameRegex.test(this.func.Name);
		},
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
		valid():boolean {
			if (!this.nameValid) return false;
			if (!this.paramNamesValid) return false;
			return true;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.func = new FrontendFunc(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			if (!this.valid) return;
			this.value.Name = this.func.Name;
			this.value.Code = this.func.Code;
			this.value.Description = this.func.Description;
			this.value.Params = this.func.Params.map(p=>new FrontendFuncParam(p.getJSON()));
			this.close();
		},
	},
	components: {
		AppFrontendFuncParameterList
	}
});
